import { gql } from '@apollo/client';

export default class ReportTemplateQuery {
    static REPORT_TEMPLATE_LIST = gql`
        query reportTemplateList {
            reportTemplateList {
                id
                name
                content
                query
                frequency
                timeScheduled
                users {
                    id
                    reportTemplateId
                    usersTableUserId
                    name
                    cellPhone
                    employeeType
                }
            }
        }
    `;

    static REPORT_TEMPLATE_FIND = gql`
        query reportTemplateFind($id: Int!) {
            reportTemplateFind(id: $id) {
                id
                name
                query
                content
                frequency
                timeScheduled
            }
        }
    `;

    static LIST_EMPLOYEES = gql`
        query listEmployees($query: String, $exclude: [Int]) {
            listEmployees(query: $query, exclude: $exclude) {
                userId
                userName
                lastName
                firstName
                middleName
                cellPhone
                employeeType
            }
        }
    `;

    static REPORT_TEMPLATE_PREVIEW = gql`
        query reportTemplatePreview($content: String!, $query: String!) {
            reportTemplatePreview(content: $content, query: $query) {
                messages
                totalCount
            }
        }
    `;
}
